export function eventListenerOpts(useCapture, abortSignal) {
  return {
    capture: useCapture,
    passive: false,
    signal: abortSignal
  };
}
/** Do not use this within the worker context. */

export function windowAddEventListener(event, listener) {
  var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var abortSignal = arguments.length > 3 ? arguments[3] : undefined;
  window.addEventListener(event, listener, eventListenerOpts(capture, abortSignal));
}
/** Do not use this within the worker context. */

export function documentAddEventListener(event, listener) {
  var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var abortSignal = arguments.length > 3 ? arguments[3] : undefined;
  document.addEventListener(event, listener, eventListenerOpts(capture, abortSignal));
}